import styled from 'styled-components';
import { createUseStyles } from 'react-jss';
export const CardWrapper = styled.div`
  .ant-card {
    border-radius: 16px;
    border: none;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
      transform: translateY(-2px);
    }
  }

  .ant-card-head {
    border-bottom: 1px solid #f0f0f0;
    padding: 0 24px;
    background: #fafafa;
    
    .ant-card-head-title {
      font-weight: 700;
      color: #1a1a1a;
      font-size: 16px;
    }
  }

  .ant-card-body {
    padding: 24px;
  }
`;


export const Wrapper = styled.div`
  background: #f8f9fa;
  min-height: 100vh;
  padding: 32px;

  @media print {
    @page {
      size: landscape;
    }
  }

  .title {
    font-family: 'Outfit', sans-serif;
    font-weight: 800;
    font-size: 28px;
    color: #1a1a1a;
    margin-bottom: 32px;
    letter-spacing: -0.5px;
  }

  .cw-content {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .input-content {
      display: flex;
      flex-direction: column;
      width: 100%;

      .label {
        font-weight: 600;
        font-size: 12px;
        color: #4a4a4a;
        margin-bottom: 8px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      input,
      select {
        width: 100%;
        background: #ffffff;
        border: 1px solid #e0e0e0;
        border-radius: 12px;
        padding: 12px 16px;
        font-size: 14px;
        transition: all 0.2s;

        &:focus {
          border-color: #ff6700;
          box-shadow: 0 0 0 4px rgba(255, 103, 0, 0.1);
          outline: none;
        }
      }
    }
  }
`;

export const useMatStyles = createUseStyles(() => ({
  searchRow: {
    display: 'flex',
    height: '52px',
    alignItems: 'center',
    marginBottom: '24px',
    gap: '12px'
  },
  modal: {
    '& .ant-modal-content': {
      borderRadius: '24px',
      overflow: 'hidden',
      padding: '0'
    },
    '& .ant-modal-header': {
      padding: '24px 32px',
      borderBottom: '1px solid #f0f0f0'
    },
    '& .ant-modal-body': {
      padding: '32px'
    }
  },
  selectType: {
    borderRadius: '12px !important',
    height: '44px',
    width: '180px',
    padding: '0 16px',
    fontWeight: '600',
    fontSize: '14px',
    color: '#FF4B01',
    background: 'rgba(255, 75, 1, 0.08)',
    border: '1px solid #FF4B01 !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s',

    '&:hover': {
      background: 'rgba(255, 75, 1, 0.12)',
    }
  },
  searchInput: {
    height: '44px',
    width: '320px',
    borderRadius: '12px',
    background: '#FFFFFF !important',
    border: '1px solid #e0e0e0',
    padding: '0 16px',
    color: '#1a1a1a',
    transition: 'all 0.2s',

    '&:focus-within': {
      border: '1px solid #FF4B01',
      boxShadow: '0 0 0 4px rgba(255, 75, 1, 0.1)',
    }
  },
  updateButton: {
    height: '44px',
    borderRadius: '12px !important',
    padding: '0 24px',
    background: '#FF4B01',
    color: '#fff',
    fontWeight: '600',
    border: 'none',
    boxShadow: '0 4px 12px rgba(255, 75, 1, 0.2)',
    transition: 'all 0.2s',

    "&:hover": {
      background: '#e64400',
      transform: 'translateY(-1px)',
      boxShadow: '0 6px 16px rgba(255, 75, 1, 0.3)',
    }
  },
  dashItem: {
    background: '#FFFFFF',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.04)',
    borderRadius: '16px',
    width: '32%',
    display: 'flex',
    height: '160px',
    padding: '24px',
    flexDirection: 'column',
    justifyContent: 'space-between',
    border: '1px solid #f0f0f0',
    transition: 'transform 0.3s ease',

    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 12px 24px rgba(0, 0, 0, 0.06)',
    }
  },
  diTop: {
    fontWeight: '600',
    fontSize: '13px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    color: '#666',
  },
  dibot: {
    fontWeight: '800',
    fontSize: '28px',
    color: '#1a1a1a',
    fontFamily: "'Outfit', sans-serif",
  },
  tableHeader: {
    background: "#f8f9fa",
    fontFamily: "'Inter', sans-serif",
    fontWeight: "700",
    fontSize: "12px",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    color: "#666",
    borderBottom: '2px solid #eee'
  },
  table: {
    background: "#FFFFFF",
    borderRadius: "16px",
    overflow: 'hidden',
    border: '1px solid #f0f0f0',
    '& .MuiDataGrid-row:hover': {
      backgroundColor: '#fafafa'
    }
  }
}));

